<div
  *ngFor="let product of products; let i = index; let last = last"
  class="d-flex justify-content-between"
  [class.mb]="!last"
>
  <div>
    <ul>
      <ng-container *ngIf="product != null">
        <li>
          <div class="circle"></div>

          <span>
            Titel
            <ng-container *ngIf="product.doTitleSidesDiffer">
              links
            </ng-container>
            :
          </span>

          <strong [class.deviation]="isAdjustment(product, 'title')">
            {{ product.title }}
          </strong>
        </li>

        <li *ngIf="product.doTitleSidesDiffer">
          <div class="circle"></div>

          <span>Titel rechts:</span>

          <strong [class.deviation]="isAdjustment(product, 'titleRight')">
            {{ product.titleRight }}
          </strong>
        </li>

        <ng-container
          *ngIf="
            product.type === PRODUCT_TYPES.IP_BOARD.value;
            else productPhoneNumbersDisplay
          "
        >
          <ng-container
            *ngIf="!collaborative; else collaborativeIPBoardPhoneNumbers"
          >
            <li *ngIf="product.phoneNumber?.length > 0">
              <div class="circle"></div>

              <span>
                Telnr
                <ng-container *ngIf="product.doPhoneNumberSidesDiffer">
                  links
                </ng-container>
                :
              </span>

              <strong [class.deviation]="isAdjustment(product, 'phoneNumber')">
                {{ product.phoneNumber }}
              </strong>
            </li>

            <li *ngIf="product.doPhoneNumberSidesDiffer">
              <div class="circle"></div>

              <span>Telnr rechts:</span>

              <strong
                [class.deviation]="isAdjustment(product, 'phoneNumberRight')"
              >
                {{ product.phoneNumberRight }}
              </strong>
            </li>
          </ng-container>

          <ng-template #collaborativeIPBoardPhoneNumbers>
            <ng-container
              *ngIf="
                !fromOldSystem && product.boardPart?.phoneNumbers?.length > 0
              "
            >
              <li *ngFor="let phoneNumber of product.boardPart.phoneNumbers">
                <div class="circle"></div>

                <span>
                  Telnr{{
                    phoneNumber.company?.regularName?.length > 0
                      ? ' ' + phoneNumber.company.regularName
                      : ''
                  }}:
                  <strong>{{ phoneNumber.phoneNumber }}</strong>
                </span>
              </li>
            </ng-container>
          </ng-template>
        </ng-container>

        <ng-template #productPhoneNumbersDisplay>
          <ng-container
            *ngIf="
              nonIPBoardProductPhoneNumberContainers != null &&
              nonIPBoardProductPhoneNumberContainers[i] != null
            "
          >
            <ng-container
              *ngIf="
                nonIPBoardProductPhoneNumberContainers[i]
                  .companyProductPhoneNumbers?.length === 1;
                else multipleProductPhoneNumbers
              "
            >
              <li>
                <div class="circle"></div>

                <span>
                  Telnr{{
                    nonIPBoardProductPhoneNumberContainers[i]
                      .companyProductPhoneNumbers[0].multiple
                      ? 's'
                      : ''
                  }}:
                </span>

                <strong>
                  {{
                    nonIPBoardProductPhoneNumberContainers[i]
                      .companyProductPhoneNumbers[0].phoneNumberDisplay
                  }}
                </strong>
              </li>
            </ng-container>

            <ng-template #multipleProductPhoneNumbers>
              <ng-container
                *ngIf="
                  nonIPBoardProductPhoneNumberContainers[i]
                    .companyProductPhoneNumbers?.length > 0
                "
              >
                <li
                  *ngFor="
                    let container of nonIPBoardProductPhoneNumberContainers[i]
                      .companyProductPhoneNumbers
                  "
                >
                  <div class="circle"></div>

                  <span>
                    Telnr{{ container.multiple ? 's' : '' }}
                    {{ container.companyName }}:
                  </span>

                  <strong>{{ container.phoneNumberDisplay }}</strong>
                </li>
              </ng-container>
            </ng-template>
          </ng-container>
        </ng-template>

        <li *ngIf="product.text?.length > 0">
          <div class="circle"></div>

          <span>
            Tekst
            <ng-container
              *ngIf="
                product.textRight?.length > 0 &&
                product.textRight != product.text
              "
            >
              links
            </ng-container>
            :
          </span>

          <strong>{{ product.text }}</strong>
        </li>

        <li
          *ngIf="
            product.textRight?.length > 0 && product.textRight != product.text
          "
        >
          <div class="circle"></div>

          <span>Tekst rechts:</span>

          <strong>{{ product.textRight }}</strong>
        </li>

        <ng-container *ngIf="product.extraBoard != null">
          <li class="mt-3">
            <div class="circle"></div>

            <span>{{ product.extraBoard.label }}:</span>

            <strong>{{ product.extraBoardText }}</strong>
          </li>

          <li>
            <div class="circle invisible"></div>

            <span>{{ product.extraBoard.label }} kleuren:</span>

            <strong>{{ product.extraBoardColor }}</strong>
          </li>
        </ng-container>

        <li *ngIf="product.stickerText?.length > 0" class="mt-3">
          <div class="circle"></div>

          <span>
            Ineens met sticker op bord
            <ng-container
              *ngIf="
                product.rightStickerText?.length > 0 &&
                product.rightStickerText != product.stickerText
              "
            >
              links
            </ng-container>
            :
          </span>

          <strong [class.deviation]="isAdjustment(product, 'sticker')">
            {{ product.stickerText }}
          </strong>
        </li>

        <li
          *ngIf="
            product.rightStickerText?.length > 0 &&
            product.rightStickerText != product.stickerText
          "
          class="mt-3"
        >
          <div class="circle"></div>

          <span>Ineens met sticker op bord rechts:</span>

          <strong [class.deviation]="isAdjustment(product, 'stickerRight')">
            {{ product.rightStickerText }}
          </strong>
        </li>

        <li *ngIf="product.immoscoopLogo == true" class="mt-3">
          <div class="circle"></div>

          <img src="/assets/immoscoop_banner.png" class="immoscoop-logo" />

          <strong class="immoscoop-text">
            Ja, het Immoscoop logo toevoegen
          </strong>
        </li>

        <li *ngIf="product.spottoLogo == true" class="mt-3">
          <div class="circle"></div>

          <img src="/assets/spotto_banner.png" class="spotto-logo" />

          <strong class="spotto-text"> Ja, het Spotto logo toevoegen </strong>
        </li>
      </ng-container>
    </ul>

    <div
      *ngIf="product?.generalExtraInfo?.length > 0"
      class="mt-3 preserve-line-break strong"
    >
      <span>{{ product.generalExtraInfo }}</span>
    </div>

    <div *ngIf="product?.draftDesign" class="mt-3 strong">
      Ik wens eerst een ontwerp te ontvangen (+ 15 €)
    </div>
  </div>

  <div
    *ngIf="
      products.length > 1 &&
      (product.productAssets | filterProductAssets).length > 0
    "
    class="card__inner-images ml-2"
  >
    <img
      *ngIf="isImage((product.productAssets | filterProductAssets)[0].asset)"
      class="max-summary-width max-summary-height clickable"
      src="/api/assets/{{
        (product.productAssets | filterProductAssets)[0].asset.uuid
      }}"
      (click)="openLightbox(product)"
    />
  </div>
</div>
